<sh-form-group
    [invalid]="isControlInvalid$ | async"
    [required]="isControlRequired$ | async"
    [label]="label"
    [labelIcons]="labelIcons"
    [helpText]="helpText"
    [currentActionItems]="currentActionItems"
    [labelActionItems]="labelActions$ | async"
    [describeLabelId]="describeLabelId"
    [errorMsg]="errorMsg"
    [id]="controlId"
    [formGroupStyling]="formGroupStyling"
>
    <div slot="inputPrefix">
        <ng-content></ng-content>
    </div>

    <ng-container *ngIf="canBeIndeterminate; then complex; else simple"> </ng-container>

    <ng-template #complex>
        <sh-form-four-state-checkbox-complex-base
            [formControl]="control"
            [label]="label"
            [id]="controlId"
            [required]="isControlRequired$ | async"
            [attr.aria-describedBy]="(isControlInvalid$ | async) ? this.describeLabelId : null"
            [invalid]="isControlInvalid$ | async"
            [title]="control.disabled ? disabledMsg : ''"
        >
        </sh-form-four-state-checkbox-complex-base>
    </ng-template>

    <ng-template #simple>
        <sh-form-four-state-checkbox-base
            [formControl]="control"
            [label]="label"
            [id]="controlId"
            [required]="isControlRequired$ | async"
            [attr.aria-describedBy]="(isControlInvalid$ | async) ? this.describeLabelId : null"
            [invalid]="isControlInvalid$ | async"
            [title]="control.disabled ? disabledMsg : ''"
        >
        </sh-form-four-state-checkbox-base>
    </ng-template>
</sh-form-group>
